import { useQuery } from '@tanstack/react-query'
import { isAxiosError } from 'axios'

import { getPublicSupplier } from './api'

export function usePublicSupplier(slug: string | undefined) {
  return useQuery({
    queryKey: ['supplier-network', 'detail', slug],
    queryFn: ({ signal }) => getPublicSupplier(slug!, signal),
    enabled: Boolean(slug),
    staleTime: 30_000,
    retry: (failureCount, error) =>
      !(isAxiosError(error) && error.response?.status === 404) &&
      failureCount < 2
  })
}
